// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-info-sidebar {
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
    background: #fff;
    color: #222;
    border-radius: 8px 0 0 8px;
    min-width: 320px;
    max-width: 100vw;
    width: 360px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
    overflow-y: auto;
}

.message-info-sidebar.bg-black {
    background: #181a20;
    color: #fff;
}

.message-info-sidebar .border-bottom {
    border-bottom: 1px solid #eaeaea;
}

.message-info-sidebar .bg-light {
    background: #f7f7fa !important;
}

.message-info-sidebar .text-dark {
    color: #222 !important;
}

.message-info-sidebar .text-white {
    color: #fff !important;
}

@media (max-width: 600px) {
    .message-info-sidebar {
        width: 100vw;
        min-width: 0;
        border-radius: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chat/MessageInfoSidebar.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,uDAAuD;IACvD,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":[".message-info-sidebar {\n    box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n    background: #fff;\n    color: #222;\n    border-radius: 8px 0 0 8px;\n    min-width: 320px;\n    max-width: 100vw;\n    width: 360px;\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    will-change: transform;\n    overflow-y: auto;\n}\n\n.message-info-sidebar.bg-black {\n    background: #181a20;\n    color: #fff;\n}\n\n.message-info-sidebar .border-bottom {\n    border-bottom: 1px solid #eaeaea;\n}\n\n.message-info-sidebar .bg-light {\n    background: #f7f7fa !important;\n}\n\n.message-info-sidebar .text-dark {\n    color: #222 !important;\n}\n\n.message-info-sidebar .text-white {\n    color: #fff !important;\n}\n\n@media (max-width: 600px) {\n    .message-info-sidebar {\n        width: 100vw;\n        min-width: 0;\n        border-radius: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
